'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var transformSearchResults = exports.transformSearchResults = function transformSearchResults(results) {
    return results.map(function (result) {
        return _extends({}, result, {
            profile_image: result.profile_image && result.profile_image.endsWith('.png') === false && result.profile_image + '_sm.jpg' || result.profile_image
        });
    });
};